module.exports = __webpack_public_path__ + "static/assets/481fbac64b59203d7ddffa564a7537d8.svg";